import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import styles from './Footer.module.css';

const Footer = ({ webdesigner, website }) => {
  return (
    <div>
      <footer className={styles.footer}>
        <a style={{ paddingRight: '12px' }} href={website} target="_blank">
          &copy; 2013 - {new Date().getFullYear()}
          <p>{webdesigner}</p>
        </a>
        <span>
          <Link to="/impressum">IMPRESSUM</Link>
          <Link to="/datenschutz">DATENSCHUTZ</Link>
        </span>
      </footer>
    </div>
  );
};

Footer.propTypes = {
  webdesigner: PropTypes.string.isRequired,
  website: PropTypes.string.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js